var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 16,
    height: 8,
    fill: "#3E3838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 8,
    height: 8,
    fill: "#3E3838"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 24,
    height: 8,
    fill: "#3E3838"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 40,
    fill: "#3E3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.04fe68995e2e833ec317a269e7255670.svg";
export { ForwardRef as ReactComponent };